import File from '@/model/File';
import Directory from '@/model/Directory';
import FileSystemObjectType from '@/enums/FileSystemObjectType';
import Image from '@/model/Image';
import Video from '@/model/Video';

class FileFactory
{
	public static create(directory: Directory, options: any): File
	{
		let file;

		switch (options.type)
		{
			case FileSystemObjectType.File:
			{
				file = new File(options);

				break;
			}

			case FileSystemObjectType.Image:
			{
				file = new Image(options);

				break;
			}

			case FileSystemObjectType.Video:
			{
				file = new Video(options);

				break;
			}
		}

		file.directory = directory;

		return file;
	}
}

export default FileFactory;